import { Component, OnInit, OnDestroy } from '@angular/core';
import 'rxjs/add/operator/takeUntil';
import { SnackbarService, SnackbarType } from './snackbar.service';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnInit, OnDestroy {
  public snackbarDisplayState = 'hidden';

  public snackbarOptions = {
    type: SnackbarType.INFORMATION,
    message: '',
    visible: false,
    duration: -1,
    dismissible: false,
    color: '#000000',
    icon: 'information',
  };

  private timeout: any;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private snackbarService: SnackbarService) {}

  public ngOnInit(): void {
    this.snackbarService.snackbarOptionsObservable.takeUntil(this.ngUnsubscribe).subscribe((value) => {
      if (value.visible) {
        if (this.snackbarOptions.visible) {
          this.snackbarDisplayState = 'hidden';
          clearTimeout(this.timeout);
          setTimeout(() => {
            this.snackbarDisplayState = 'shown';
          }, 250);
        } else {
          this.snackbarDisplayState = 'shown';
        }

        this.snackbarOptions = value;

        if (this.snackbarOptions.duration > 0) {
          this.timeout = setTimeout(() => {
            this.snackbarService.dismiss();
          }, this.snackbarOptions.duration);
        }
      } else {
        this.snackbarDisplayState = 'hidden';
      }
    });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public dismiss(): void {
    clearTimeout(this.timeout);
    this.snackbarService.dismiss();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/snackbar/snackbar.component.ts